import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { Card, ListGroup, Container, Row, Col, Alert, Spinner, Image, Form } from 'react-bootstrap';
import './PainelChamadas.css'; // Criaremos este arquivo para estilização
import axios from 'axios'; // Importar axios para buscar dados da entidade
import DicasSaude from '../components/painel/DicasSaude'; // NOVO: Importar o componente de dicas
import config from '../config'; // Importar config para a URL da API
// Configuração do Laravel Echo (geralmente fica em um arquivo bootstrap.js, mas colocamos aqui para clareza)
window.Pusher = Pusher;

const echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.REACT_APP_PUSHER_APP_KEY,
    cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
    forceTLS: true
});

const PainelChamadas = () => {
    const { entidadeId } = useParams(); // Pega o ID da entidade da URL (ex: /painel/1)
    const [chamadaAtual, setChamadaAtual] = useState(null);
    const [historicoChamadas, setHistoricoChamadas] = useState([]);
    const [conectado, setConectado] = useState(false);
    const [error, setError] = useState(null);
    const audioRef = useRef(null); // Ref para o elemento de áudio

    // NOVO: Ref para armazenar o ID do timeout e poder limpá-lo
    const chamadaTimeoutRef = useRef(null);
    
    // --- NOVOS ESTADOS ---
    const [entidade, setEntidade] = useState(null);
    const [isLoadingEntidade, setIsLoadingEntidade] = useState(true);
    const [currentTime, setCurrentTime] = useState(new Date());
    const [conteudoEmExibicao, setConteudoEmExibicao] = useState('dicas'); // 'dicas' ou 'tv'

    // Efeito para buscar os dados da entidade
    useEffect(() => {
        if (!entidadeId) return;
        
        const fetchEntidade = async () => {
            setIsLoadingEntidade(true);
            try {
                // Usa a nova rota pública para buscar os dados da entidade
                const response = await axios.get(`/api/public/entidades/${entidadeId}`);
                setEntidade(response.data); // A resposta agora é o próprio objeto da entidade
            } catch (err) {
                setError("Não foi possível carregar os dados da clínica.");
                console.error("Erro ao buscar dados da entidade:", err);
            } finally {
                setIsLoadingEntidade(false);
            }
        };
        fetchEntidade();
    }, [entidadeId]);

    // Efeito para o relógio
    useEffect(() => {
        const timer = setInterval(() => setCurrentTime(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    // NOVO: Efeito separado para lidar com o histórico.
    // Ele roda apenas quando `chamadaAtual` muda.
    useEffect(() => {
        // Adiciona a chamada anterior ao histórico (se houver)
        if (chamadaAtual) {
            setHistoricoChamadas(prevHistorico => {
                const historicoAtualizado = [chamadaAtual, ...prevHistorico];
                return historicoAtualizado.slice(0, 5);
            });
        }
    }, [chamadaAtual]);

    useEffect(() => {
        if (!entidadeId) {
            setError("ID da entidade não fornecido na URL.");
            return;
        }

        const channelName = `painel-chamadas.${entidadeId}`;

        try {
            const channel = echo.channel(channelName);

            channel.listen('PacienteChamado', (data) => {
                console.log('Nova chamada recebida:', data);

                // NOVO: Limpa qualquer timeout anterior se uma nova chamada chegar
                if (chamadaTimeoutRef.current) {
                    clearTimeout(chamadaTimeoutRef.current);
                }

                // Toca o som de notificação
                if (audioRef.current) {
                    audioRef.current.play().catch(e => console.error("Erro ao tocar áudio:", e));
                }

                // Define a nova chamada como a chamada atual
                setChamadaAtual(data);

                // NOVO: Define um temporizador para limpar a chamada atual após 15 segundos
                chamadaTimeoutRef.current = setTimeout(() => {
                    setChamadaAtual(null);
                    chamadaTimeoutRef.current = null;
                }, 15000); // 15000 milissegundos = 15 segundos
            });

            // Eventos de controle do Pusher/Echo
            echo.connector.pusher.connection.bind('connected', () => {
                setConectado(true);
                setError(null);
            });

            echo.connector.pusher.connection.bind('unavailable', () => {
                setError("Não foi possível conectar ao serviço de tempo real. Verificando...");
                setConectado(false);
            });

            echo.connector.pusher.connection.bind('error', (err) => {
                setError(`Erro de conexão: ${err.error?.data?.message || 'Verifique a configuração'}`);
                setConectado(false);
            });

            console.log(`Ouvindo o canal: ${channelName}`);

        } catch (e) {
            setError(`Erro ao iniciar o Echo: ${e.message}`);
            console.error("Erro ao iniciar o Echo:", e);
        }

        // Função de limpeza para se desinscrever do canal ao desmontar o componente
        return () => {
            console.log(`Saindo do canal: ${channelName}`);
            echo.leave(channelName);
            // NOVO: Limpa o timeout se o componente for desmontado
            if (chamadaTimeoutRef.current) {
                clearTimeout(chamadaTimeoutRef.current);
            }
        };
    }, [entidadeId]); // REMOVIDO `chamadaAtual` da dependência

    if (isLoadingEntidade) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <Spinner animation="border" role="status" />
            </div>
        );
    }
    return (
        <Container fluid className="painel-container">
            {/* Elemento de áudio para a notificação */}
            <audio ref={audioRef} src="/sounds/notification-1-270124.mp3" preload="auto"></audio>

            <Row>
                <Col md={8} className="chamada-principal-col">
                    {/* --- NOVO CABEÇALHO --- */}
                    <header className="painel-header">
                        <div className="logo-container">
                            {entidade?.logo_path && (
                                <Image src={`${config.apiBaseURL}/storage/${entidade.logo_path}`} alt={`Logo de ${entidade.nome}`} className="logo-clinica" />
                            )}
                            <h1>{entidade?.nome || 'Painel de Chamadas'}</h1>
                        </div>
                        <div className="relogio-container">
                            {currentTime.toLocaleTimeString('pt-BR')}
                        </div>
                        {/* --- NOVO SELETOR DE CONTEÚDO --- */}
                        <div className="conteudo-seletor">
                            <Form.Select 
                                size="sm" 
                                value={conteudoEmExibicao} 
                                onChange={(e) => setConteudoEmExibicao(e.target.value)}
                                aria-label="Selecionar conteúdo de espera"
                            >
                                <option value="dicas">Dicas de Saúde</option>
                                <option value="tv">TV Ao Vivo</option>
                            </Form.Select>
                        </div>
                    </header>

                    {/* Card Superior: Exibe a chamada atual ou a mensagem de "Aguardando" */}
                    <Card className="chamada-atual-card">
                        <Card.Body>
                            {chamadaAtual ? (
                                <>
                                    <div className="paciente-nome">{chamadaAtual.pacienteNome}</div>
                                    <div className="medico-nome">Dr(a). {chamadaAtual.medicoNome}</div>
                                    <div className="local-atendimento">{chamadaAtual.local}</div>
                                </>
                            ) : (
                                <div className="aguardando-chamada">
                                    Aguardando Chamadas...
                                </div>
                            )}
                        </Card.Body>
                    </Card>

                    {/* Card Inferior: Exibe as dicas de saúde continuamente */}
                    <Card className="dicas-saude-card">
                        <Card.Body>
                            {conteudoEmExibicao === 'dicas' ? (
                                <DicasSaude />
                            ) : (
                                <div className="conteudo-espera">
                                    {/* Substitua pela URL de incorporação do seu canal de TV */}
                                    <iframe
                                        src="https://www.youtube.com/embed/mN2U0RdXoio?autoplay=1&mute=1&loop=1&playlist=mN2U0RdXoio&controls=0"
                                        title="TV Ao Vivo"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4} className="historico-col">
                    <Card className="historico-card">
                        <Card.Header as="h5">Últimas Chamadas</Card.Header>
                        <ListGroup variant="flush">
                            {historicoChamadas.length > 0 ? (
                                historicoChamadas.map((chamada, index) => (
                                    <ListGroup.Item key={index} className="historico-item">
                                        <span className="historico-paciente">{chamada.pacienteNome}</span>
                                        <span className="historico-local">{chamada.local}</span>
                                    </ListGroup.Item>
                                ))
                            ) : (
                                <ListGroup.Item className="text-muted text-center">
                                    Nenhuma chamada anterior.
                                </ListGroup.Item>
                            )}
                        </ListGroup>
                    </Card>
                </Col>
            </Row>
            {!conectado && (
                <Alert variant="danger" className="conexao-status">
                    {error || "Tentando conectar ao serviço de tempo real..."}
                </Alert>
            )}
        </Container>
    );
};

export default PainelChamadas;
